
<template>
  <div class="tmb">
    <!-- <div class="show-box"></div> -->
    <div class="top">
      <p>检测结果</p>
      <h1>{{ msiData.result }}</h1>
      <div class="text">
        {{ msiData.resultText }}
      </div>
    </div>
    <div class="bottom">
      <h1>结果解析</h1>
      <div class="show-box"></div>
      <div class="padd-box">
        <div class="text">
          {{ msiData.jxText }}
        </div>
        <div class="border" v-if="msiData.careful"></div>
      </div>
      <div class="iconClss" v-if="msiData.careful">
        <p class="_cre">!</p>
        <p class="_text">
          {{ msiData.careful }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    msiData: {
      type: Object,
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(52, 68, 132, 0) 0%,
    rgba(52, 68, 132, 0.1) 100%
  );
}
.tmb {
  font-family: @family;
  .border {
    border-top: 1px solid #e3e5e8;
  }
  .iconClss {
    display: flex;
    padding: 10px 24px 30px;

    ._cre {
      width: 14px;
      min-width: 14px;
      height: 14px;
      background: #ffdb4d;
      border-radius: 14px;
      line-height: 14px;
      text-align: center;
      margin-right: 11px;
    }
    ._text {
      font-size: 12px;
      font-weight: 400;
      color: #9095a7;
      line-height: 17px;
    }
  }
  .bottom {
    background: @background_color;
    // box-shadow: 0px 10px 20px -4px rgba(52, 68, 132, 0.16);
    border-radius: 10px;
    .padd-box {
      padding: 10px 24px;
    }
    .text {
      font-size: 15PX;
      font-weight: 400;
      color: #5f697d;
      line-height: 30px;
      padding-bottom: 20px;
      word-break: break-all;
      text-align: justify;
      text-justify: newspaper;
      font-family: @family;
    }
    h1 {
      height: 70px;
      line-height: 70px;
      font-size: 18PX;
      font-weight: 500;
      font-family: @family;
      color: #2f354d;
      padding-left: 24px;
    }
  }
  .top {
    padding: 30px 24px;
    background: @background_color;
    border-radius: 10px;
    margin-bottom: 20px;
    .text {
      font-size: 13PX;
      font-weight: 400;
      color: #2f354d;
      padding: 20px 0 0;
      word-break: break-all;
      text-align: justify;
      text-justify: newspaper;
      font-family: @family;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: #a4a9bf;
      line-height: 17px;
      margin-bottom: 4px;
    }
    h1 {
      font-size: 15PX;
      color: #2F354D;
      border-bottom: 1px solid #e3e5e8;
      padding-bottom: 20px;
      font-family: @family;
      font-weight: 500;
    }
  }
}
</style>

